export default "__VITE_ASSET__DP6Z7qNQ__"